var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.Class},[_c('div',{class:_vm.ClassTitle},[_vm._v(" Ϙ ")]),(_vm.isUnlocked)?_c('div',{staticClass:"l-outer-effarig-content-container"},[_vm._v(" hey ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }